import React from 'react'
import { Navigate } from 'react-router-dom'
import { Path } from '@plvs/const'
import { UserOnlineStatusProvider } from '@plvs/respawn/features/userOnlineStatus/UserOnlineStatusProvider'
import { ManageTeamsProvider } from '@plvs/respawn/containers/manageTeams/ManageTeamsProvider'
import { WaitTillLoaded } from '@plvs/respawn/features/layout'
import { useUserIdentityFn } from '@plvs/client-data/hooks'
import { ManageTeamsPage } from './ManageTeamsPage'
import { AppPage } from '../../page'
import { canViewManagePage } from './manageHelpers'

export const ManageTeamsWrapper: React.FC = () => {
  const {
    isCoachAtOrg,
    isPlayerAtOrg,
    orgCompetitionGroup,
    loading: identityLoading,
  } = useUserIdentityFn()

  const hasManageTeams = canViewManagePage({
    isCoachAtOrg,
    isPlayerAtOrg,
    competitionGroup: orgCompetitionGroup,
  })

  return (
    <AppPage title="Manage Teams">
      <WaitTillLoaded loading={identityLoading}>
        {hasManageTeams ? (
          <UserOnlineStatusProvider>
            <ManageTeamsProvider>
              <ManageTeamsPage />
            </ManageTeamsProvider>
          </UserOnlineStatusProvider>
        ) : (
          <Navigate to={Path.Dashboard} />
        )}
      </WaitTillLoaded>
    </AppPage>
  )
}
